import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=7b08800e&scoped=true"
import script from "./PromotionDetails.vue?vue&type=script&lang=js"
export * from "./PromotionDetails.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetails.vue?vue&type=style&index=0&id=7b08800e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b08800e",
  null
  
)

export default component.exports